var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#1D1C1B",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0363 17.282H17.378L17.1446 17.057C17.9613 16.107 18.453 14.8737 18.453 13.532C18.453 10.5403 16.028 8.11533 13.0363 8.11533C10.0446 8.11533 7.61963 10.5403 7.61963 13.532C7.61963 16.5237 10.0446 18.9487 13.0363 18.9487C14.378 18.9487 15.6113 18.457 16.5613 17.6403L16.7863 17.8737V18.532L20.953 22.6903L22.1946 21.4487L18.0363 17.282ZM13.0363 17.282C10.9613 17.282 9.2863 15.607 9.2863 13.532C9.2863 11.457 10.9613 9.78199 13.0363 9.78199C15.1113 9.78199 16.7863 11.457 16.7863 13.532C16.7863 15.607 15.1113 17.282 13.0363 17.282ZM15.1196 13.1153H10.953V13.9487H15.1196V13.1153Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomout);
export default __webpack_public_path__ + "static/media/zoomout.ea21744e7feb4694ed55b73a8f1ef61d.svg";
export { ForwardRef as ReactComponent };